import { type MouseEvent, useCallback } from 'react';
import { css, type Theme } from '@emotion/react';
import { Dialog } from 'client/components/Dialog/Dialog';
import { useLog } from 'client/components/Log/useLog';
import { LogView } from './LogView';

export const LogDialog = () => {
  const { isDialogFullscreen, isDialogOpen, closeLogDialog, toggleFullscreen } = useLog();

  const handleClose = useCallback(() => {
    setTimeout(() => {
      closeLogDialog();
    }, 0);
  }, [closeLogDialog]);

  const handleToggleFullscreen = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      toggleFullscreen();
    },
    [toggleFullscreen]
  );

  return (
    <Dialog
      open={isDialogOpen}
      icon={null}
      title={''}
      description={null}
      actions={null}
      hideHeader
      width={1400}
      fullscreen={isDialogFullscreen}
      onClose={handleClose}
      css={[dialogStyle, isDialogFullscreen && fullscreenDialogStyle]}
    >
      <LogView isDialog={true} fullscreen={isDialogFullscreen} onToggleFullscreen={handleToggleFullscreen} />
    </Dialog>
  );
};

const dialogStyle = (theme: Theme) => css`
  > .MuiDialog-container > .MuiPaper-root {
    padding: 0;
    height: calc(100vh - 2rem);

    > .MuiDialogContent-root > .MuiListItem-root {
      padding-bottom: 16px;
    }
  }

  .MuiDialogContent-root {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
`;

const fullscreenDialogStyle = css`
  > .MuiDialog-container > .MuiPaper-root {
    height: 100vh;
  }
`;
